var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHappyLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 43"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0s256 41.716 512 41.716S1024 0 1024 0v43H0V0z"
  })));
}

export default SvgHappyLine;